import * as React from 'react';
import { ErrorBoundary } from 'bernie-view';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { ExperienceTemplateRenderer } from 'experience-template-renderer-react';
export const MainRegion = ({
  templateComponent
}) => {
  const {
    children
  } = templateComponent;
  if (!children || children.length === 0) {
    return null;
  }
  return React.createElement(ErrorBoundary, {
    label: "hotel.masterPage.main"
  }, React.createElement("section", {
    "data-stid": "search-results__main",
    itemScope: true,
    itemType: 'https://schema.org/Hotel'
  }, React.createElement(EGDSSpacing, {
    margin: {
      small: {
        inline: 'three'
      },
      medium: {
        inline: 'unset'
      }
    }
  }, React.createElement("div", null, React.createElement(ExperienceTemplateRenderer, {
    templateComponents: children
  })))));
};